<template>
  <v-card>

    <v-progress-circular v-if="loading"
                         indeterminate
                         color="primary">
    </v-progress-circular>

    <v-card-text>
      <siteNotification-properties-view v-if="siteNotification != null"
                                   :siteNotification="siteNotification">
      <template v-slot:append>
        <entity-properties-row>
          <v-btn v-if="$featurePermissions.siteNotificationCRUD"
                 tile
                 color="primary"
                 @click="openEditDialog">
            {{ $t('actions.modify') }}
            <v-icon right dark>
              mdi-border-color
            </v-icon>
          </v-btn>
        </entity-properties-row>
      </template>
      </siteNotification-properties-view>
      <siteNotification-dialog ref="siteNotificationDialog" @done="reload"/>
    </v-card-text>
  </v-card>
</template>

<script>
import Vue from 'vue';
import EntityPropertiesRow from '@/components/entity-crud/EntyPropertiesRow';
import SiteNotificationsService from '@/services/SiteNotificationsService';
import SiteNotificationDialog from '@/views/sitenotification/SiteNotificationDialog';
import SiteNotificationPropertiesView from '@/views/sitenotification/SiteNotificationPropertiesView';

export default Vue.extend({
  name: 'SiteNotificationDetails',
  components: {
    SiteNotificationDialog,
    SiteNotificationPropertiesView,
    EntityPropertiesRow,
  },
  data() {
    return {
      siteNotification: null,
      documents: [],
      loading: false,

    };
  },
  mounted() {
    this.reload();
  },
  methods: {
    reload() {
      this.loading = true;
      SiteNotificationsService.get(this.siteNotificationId).then(result => {
        this.siteNotification = result.data;
      }).catch(err => {
        console.log(JSON.stringify(err));
      }).finally(() => {
        this.loading = false;
      });
      this.$store.dispatch('siteNotificationsViewerState/update');
    },

    openEditDialog() {
      this.$refs.siteNotificationDialog.openEditForSiteNotification(this.siteNotificationId);
    },
  },

  computed: {
    siteNotificationId() {
      return parseInt(this.$route.params.id, 10);
    },
  },
});
</script>
